package com.iregained.site.components.sections.about.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val AboutCtaButtonStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier
            .backgroundColor(com.varabyte.kobweb.compose.ui.graphics.Colors.White)
            .color(palette.brand.primary) // Teal text on white button
            .transition(
                Transition.of("transform", 0.3.s),
                Transition.of("box-shadow", 0.3.s)
            )
    }
    hover {
        val palette = colorMode.toSitePalette()
        Modifier
            .translateY((-4).px) // Lift effect
            .boxShadow(0.px, 15.px, 30.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.25f))
    }
}